import type { RaRecord } from "react-admin";
import { SABIL_TYPE_OPTIONS } from "@/constants";
import { navigateToBaseRoute } from "@/utils/route-utility";

export type SabilReceiptRow = RaRecord & {
  sabilId?: string;
  sabilData?: RaRecord & {
    id?: string;
    sabilNo?: string;
    sabilType?: string;
    itsNo?: string;
    name?: string;
    itsdata?: { Full_Name?: string };
  };
};

export const DEFAULT_SABIL_TYPE_FILTER = "CHULA";

export const sabilTypeLabel = (type?: string) =>
  SABIL_TYPE_OPTIONS.find((option) => option.id === type)?.name ?? type ?? "—";

export const receiptDisplayName = (record: SabilReceiptRow) =>
  record.sabilData?.name || record.sabilData?.itsdata?.Full_Name || "—";

export const sabilDataId = (record: SabilReceiptRow) => record.sabilData?.id || record.sabilId;

export const sabilNoLabel = (record: SabilReceiptRow) => record.sabilData?.sabilNo ?? "—";

export const navigateToSabilShow = (id: string | number) => {
  navigateToBaseRoute("sabil", null, ["sabilData", String(id), "show"]);
};

export const openReceiptPrint = (id: string | number) => {
  window.open(`#/sabil-receipt?receiptId=${id}`, "_blank");
};

export const getFilterFromURL = () => {
  const fallback = { sabilType: DEFAULT_SABIL_TYPE_FILTER };
  if (typeof window === "undefined") return fallback;

  const filterParam = new URLSearchParams(window.location.search).get("filter");
  if (!filterParam) return fallback;

  try {
    const parsed = JSON.parse(filterParam) as Record<string, unknown>;
    return { ...parsed, sabilType: (parsed.sabilType as string) || DEFAULT_SABIL_TYPE_FILTER };
  } catch {
    return fallback;
  }
};

export const sabilExportFilenameSuffix = (sabilType?: string) => {
  const tab = SABIL_TYPE_OPTIONS.find((option) => option.id === sabilType);
  if (tab?.name) {
    return tab.name.toLowerCase().replace(/\s+/g, "").replace(/-/g, "");
  }
  return sabilType?.toLowerCase() || "sabilreceipts";
};
